// store any values that need to be referenced in form

const FormSharedValuesActions = {
  SET_VALUE_STATE: 'FormSharedValues.SET_FORM_SHARED_VALUE_STATE',
  RESET_VALUES_STATE: 'FormSharedValues.RESET_FORM_SHARED_VALUES_STATE',
};

export default FormSharedValuesActions;
